function pwaDialogHandler() {
  const dialog = useConfirmDialog();

  return {
    ...dialog,
  };
}

export const usePwaDialogHandler = createSharedComposable(pwaDialogHandler);
